/**
 * Created by Christof Sander on 13.10.2016.
 */

const CONSTANTS = require('../../lib/constants');
const utils = require('../../lib/utils');
var store = require('../../lib/store');

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		modeDependentContainerComponent: {
			tabStrip: [
				'/',
				'base',
				'tabStrip',
				'tabStrip'
			]
		},
		separatorMode: 'tabStrip',
		availableSeparators: {
			initialized: false,
			list: []
		},
		parentFormResourceKey: 'relationships',
		separatorKey: 'langCode'
	},

	model: {
		nrOfRelationshipElements: 0
	},

	methods: {
		/**
		 * this function is used to handle validation errors in relationship forms.
		 *
		 * @param childComponent		Component - subForm which failed on validation
		 * @param validationResult		{} - validationResult given by validator
		 * @param firstError			boolean - is this the global first error within the actual mainForm
		 */
		handleRelationshipChildValidationError: function(childComponent, validationResult, firstError){
			// handle validation error separatorMode dependent
			switch (this.config.separatorMode) {
				case 'tabStrip':
					if(childComponent && this.actions.relationContainer && this.actions.relationContainer.source.load.component){
						// estimate tab-registerSecret
						var tabRegisterSecret;
						childComponent.closest('base_tabStrip_tabContent', function(tabContentComponent){
							tabRegisterSecret = tabContentComponent.config.registerSecret;
						});

						if(tabRegisterSecret !== undefined){
							this.actions.relationContainer.source.load.component.markTab(tabRegisterSecret, validationResult.invalid ? 'validationFailed' : '');
							this.actions.relationContainer.source.load.component.focusTab(tabRegisterSecret, true);
						}
					}
					break;

					// TODO: inline?
			}
		},

		/**
		 * this function returns the resourceDataIndex according to the given separatorKey or void in an error case.
		 *
		 * @param 	separatorKey		mixed - separator key to find
		 * @return 	void | int - resourceDataIndex
		 */
		getRelationshipDataIndex: function(separatorKey){
			var self = this;
			var result;

			// find data according to separator
			if(self.resourceData && self.resourceData.data){
				utils.forEach(self.resourceData.data, function (resource, resourceIndex) {
					if(self.config.availableSeparators.type === 'dataIndex'){
						if(resourceIndex == ((self.config.availableSeparators.list[separatorKey] || {}).key || separatorKey)){
							result = resourceIndex;
							return false;
						}
					}
				 	else if (resource.attributes && resource.attributes[self.config.separatorKey] == ((self.config.availableSeparators.list[separatorKey] || {}).key || separatorKey)) {
						result = resourceIndex;
						return false;
					}
				});
			}

			return result;
		},

		/**
		 * this function adds an relationship element to the dom according to the given parameters.
		 *
		 * @param separatorKey
		 * @param separator
		 * @returns {*}
		 */
		addRelationshipElement: function(separatorKey, separator){
			separator = separator || {};

			var self = this;
			var data;
			self.model.nrOfNonIdentifiedRelationshipDataSets = self.model.nrOfNonIdentifiedRelationshipDataSets || 0;
			self.model.nrOfRelationshipElements++;

			// find data according to separator
			if ((separator.resourceIndex = self.getRelationshipDataIndex(separatorKey)) == undefined) {
				separator.resourceIndex = (self.resourceData.data && Array.isArray(self.resourceData.data) ? self.resourceData.data.length : 0) + self.model.nrOfNonIdentifiedRelationshipDataSets++;
			}

			// set data according to resourceIndex
			if (self.resourceData.data && self.resourceData.data[separator.resourceIndex]){
				data = { data: self.resourceData.data[separator.resourceIndex] };
			}
			else {
				data = { data: { attributes: { }}};
				data.data.attributes[self.config.separatorKey] = separatorKey;
			}
			data.data.resource = separator.resource || {};

			// perform relationshipElement add action(s)
			switch (self.config.separatorMode) {
				case 'tabStrip':
					return self.performAction(
						self.prepareAction({
							type: CONSTANTS.COMPONENT.ACTION.TYPE.TAB,
							source: {
								tab: {
									componentData: {
										resourceData: {
											icon: separator.icon,
											title: separator.title
										}
									}
								},
								tabContent: {
									componentData: {
										component: [
											'/',
											'base',
											'form',
											'form'
										],
										resourceData: data,
										config: {
											separatorKey: separatorKey,
											subFormAlias: self.config.subFormAlias,
											relationshipDataIndex: separator.resourceIndex,
											submitAllResources: self.config.submitAllResources
										},
										model: {
											fields: self.model.fields
										},
										formMapping: self.formMapping,
										validatorRuleSet: self.validatorRuleSet,
										validatorRuleSetID: self.componentID + '-' + separator.resourceIndex
									}
								}
							},
							target: {
								element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR,
								selector: '> .content > .base_tabStrip_tabStrip'
							}
						})
					);

				case 'component':
					return self.performAndStoreAction(
						undefined,
						self.prepareAction({
							type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
							source: {
								load: {
									componentData: {
										component: self.config.separatorComponent,
										resourceData: data,
										config: {
											separatorKey: separatorKey,
											subFormAlias: self.config.subFormAlias,
											relationshipDataIndex: separator.resourceIndex,
											isHorizontal: self.config.isHorizontal,
											preventAllFieldLabels: self.config.preventAllFieldLabels,
											submitAllResources: self.config.submitAllResources
										},
										model: {
											fields: self.model.fields
										},
										formMapping: self.formMapping,
										validatorRuleSet: self.validatorRuleSet,
										validatorRuleSetID: self.componentID + '-' + separator.resourceIndex
									}
								}
							},
							target: {
								element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SELF,
								position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.APPEND
							}
						})
					);

				case 'inline':
					return self.performAndStoreAction(
						undefined,
						self.prepareAction({
							type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
							source: {
								load: {
									componentData: {
										component: [
											'/',
											'base',
											'form',
											'form'
										],
										resourceData: data,
										config: {
											separatorKey: separatorKey,
											subFormAlias: self.config.subFormAlias,
											relationshipDataIndex: separator.resourceIndex,
											isHorizontal: self.config.isHorizontal,
											preventAllFieldLabels: self.config.preventAllFieldLabels && (!self.config.isHorizontal || self.model.nrOfRelationshipElements > 1),
											submitAllResources: self.config.submitAllResources
										},
										model: {
											fields: self.model.fields
										},
										formMapping: self.formMapping,
										validatorRuleSet: self.validatorRuleSet,
										validatorRuleSetID: self.componentID + '-' + separator.resourceIndex
									}
								}
							},
							target: {
								element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR,
								selector: '> .content',
								position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.APPEND
							}
						})
					);
			}
		},

		/**
		 * dynamic add of relationship element
		 *
		 * @returns {*}
		 */
		showInsert: function(){
			return this.addRelationshipElement();
		},

		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var self = this;
			var relationshipSourceComponent = (additionalData || {}).sourceComponent;
			if(relationshipSourceComponent){
				var sourceComponentConfig = relationshipSourceComponent.config || {};
				if(sourceComponentConfig.relationshipDataIndex !== undefined){
					this.subFieldsToModel(sourceComponentConfig.subFormAlias, {}, true, sourceComponentConfig.relationshipDataIndex, sourceComponentConfig.parentFormResourceKey);
					var firstOneFound = false;
					// correct preventAllFieldLabels flag of first inline element if necessary
					this.find('base_form_form', undefined, function(form){
						if(form.componentIndex === relationshipSourceComponent.componentIndex){
							firstOneFound = true;
						} else if(firstOneFound){
							form.config.preventAllFieldLabels = false;
							form.refresh(false);
							return 'break';
						} else {
							return 'break';
						}
					});
					self.model.nrOfRelationshipElements--;
					relationshipSourceComponent.destroy();
					return utils.promise.resolve();
				}
			}
		}
	},

	hooks: {
		include: function($element, options){
			var containerComponentConfig = {};

			// TODO: REWORK THIS HACK
			if(this.config.separatorMode === 'tabStrip'){
				containerComponentConfig.closableTabs = false;
			}

			// add base container for this relationship if necessary
			if(this.config.modeDependentContainerComponent[this.config.separatorMode]){
				this.performAndStoreAction(
					'relationContainer',
					this.prepareAction({
						type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
						source: {
							load: {
								componentData: {
									component: this.config.modeDependentContainerComponent[this.config.separatorMode],
									config: containerComponentConfig
								}
							}
						},
						target: {
							element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SUB_SELECTOR,
							selector: '> .content',
							position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.HTML
						}
					})
				);
			}
		},

		attach: function($element, options){
			if(!options.refresh) {

				// prepare default actions
				this.prepareDefaultActions();

				// init
				var self = this;
				// var data;
				// var nrOfNonIdentifiedRelationshipDataSets = 0;
				var performActions = [];

				// init availableSeparators if necessary
				if(!self.config.availableSeparators.initialized){
					self.config.availableSeparators.initialized = true;
					if(utils.isFunction(self.updateAvailableSeparators)){
						self.updateAvailableSeparators();
					}
					else if(utils.isCollection(self.config.availableSeparators) && self.config.availableSeparators.type != undefined){
						// take availableLangCodes from storage
						if(self.config.availableSeparators.type === 'availableLangCodes'){
							var storage = store.get(self.requestID, self.sessionID, self.serviceDomain);
							if(storage.app && storage.app.webService && storage.app.webService.config && storage.app.webService.config.availableLangCodes){
								self.config.availableSeparators.list = storage.app.webService.config.availableLangCodes;
							}
						}
						// take available dataIndexes
						else if(self.config.availableSeparators.type === 'dataIndex'){
							self.config.availableSeparators.list = [];
							for(var dataIndex in self.resourceData.data || []){
								self.config.availableSeparators.list[dataIndex] = true;
							}
						}
						// take separators from model field
						else if(self.config.availableSeparators.type === 'field' && self.config.availableSeparators.fieldCode != undefined){
							var fieldProperties;
							var field;
							if((fieldProperties = self.getFieldProperties(self.config.availableSeparators.fieldCode)) != undefined){
								if(fieldProperties.modelFieldIndex && self.model.fields[fieldProperties.modelFieldIndex]){
									field = self.model.fields[fieldProperties.modelFieldIndex];
								}
							}

							if(field != undefined && field.atom != undefined){
								if((field.atom.dataType === 'category-picker' || field.atom.dataType === 'resource-picker' || field.atom.dataType === 'template-picker') && field[field.atom.dataType + '-data'] != undefined && field[field.atom.dataType + '-data'].options){
									self.config.availableSeparators.list = {};
									utils.forEach(field[field.atom.dataType + '-data'].options, function(separatorOption){
										self.config.availableSeparators.list[separatorOption.value] = {
											title: 		separatorOption.name,
											resource:  	separatorOption.resource || {}
										};
									});
								}
							}
						}
					}
				}

				utils.forEach(self.config.availableSeparators.list, function (separator, separatorKey) {
					performActions.push(self.addRelationshipElement(separatorKey, separator));
				});

				// init right container state
				switch (self.config.separatorMode) {
					case 'tabStrip':
						utils.promise.performAll(self, performActions).then(function(context){
							self.find('base_tabStrip_tabStrip', function(tabStripComponent){
								tabStripComponent.focusTab(0);
							});
						});
						break;
				}
			}
		}
	}
};
